import { render, staticRenderFns } from "./BannerOrderExpress.vue?vue&type=template&id=8b7ebe1c&"
import script from "./BannerOrderExpress.vue?vue&type=script&lang=js&"
export * from "./BannerOrderExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports